import styled from 'styled-components';

export const LockConfirmWrapperStyled = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  padding-bottom: 48px;
`;
